import React from 'react';

/** Recursively extract the plain-text content of a rendered React node. */
export const textContent = (node) => {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(textContent).join('');
  if (node.props?.children !== undefined) return textContent(node.props.children);
  return '';
};

/** Collect the <p> elements inside (possibly nested) blockquote children. */
export const collectParagraphs = (children) => {
  const out = [];
  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;
    if (child.type === 'blockquote') {
      out.push(...collectParagraphs(child.props.children));
    } else if (child.type === 'p') {
      out.push(child);
    }
  });
  return out;
};

/**
 * Split a paragraph element's children into visual lines (markdown soft breaks
 * arrive as "\n" inside text nodes, hard breaks as <br>). Returns an array of
 * arrays of nodes.
 */
export const splitLines = (paragraph) => {
  const lines = [[]];
  const push = (node) => lines[lines.length - 1].push(node);
  React.Children.forEach(paragraph.props.children, (node) => {
    if (typeof node === 'string' && node.includes('\n')) {
      node.split('\n').forEach((part, i) => {
        if (i > 0) lines.push([]);
        if (part) push(part);
      });
    } else if (React.isValidElement(node) && node.type === 'br') {
      lines.push([]);
    } else {
      push(node);
    }
  });
  return lines.filter((line) => line.length);
};
